import { z } from "zod";

/**
 * Public env vars exposed to the SPA. These are NOT secrets — they are baked
 * into the client bundle. Server-side secrets (BETTER_AUTH_SECRET, SITE_URL,
 * etc.) live in the Convex env, not here.
 *
 * The SPA's own origin is intentionally NOT an env var — read it from
 * `window.location.origin` when needed.
 */
const envSchema = z.object({
  VITE_CONVEX_URL: z.string().url(),
  VITE_CONVEX_SITE_URL: z.string().url(),
});

function readEnv(value: unknown): string {
  return typeof value === "string" ? value : "";
}

const parsed = envSchema.safeParse({
  VITE_CONVEX_URL: readEnv(import.meta.env.VITE_CONVEX_URL),
  VITE_CONVEX_SITE_URL: readEnv(import.meta.env.VITE_CONVEX_SITE_URL),
});

if (!parsed.success) {
  console.error("Environment is missing or invalid:", parsed.error.flatten().fieldErrors);
  throw new Error(
    "Missing required env vars. See .env.example for VITE_CONVEX_URL and VITE_CONVEX_SITE_URL.",
  );
}

export const env = parsed.data;
